module.exports = __webpack_public_path__ + "img/undraw_not_found_60pq.8c3d2a79.svg";